<template>
  <v-tooltip nudge-top="35" nudge-right="10" color="#fff" left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :disabled="loading"
        :loading="loading"
        @click="downloadFiles"
        v-bind="attrs"
        v-on="on"
        class="btn_33 edit_btn"
      >
        <vue-icon icon="fileIcon"></vue-icon>
      </v-btn>
    </template>
    <span>{{ $t("downloadFile") }}</span>
  </v-tooltip>
</template>

<script>
import { downloadBlobFile } from "@/utils/pureFunctions";

export default {
  name: "multiple-downloader",
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    fileName: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    openAndDownloadWindow(link) {
      return this.$http.post(`attachment/file/${link}`, null, {
        responseType: "blob",
      });
    },
    async downloadFiles() {
      const downloadPromises = this.files.map(this.openAndDownloadWindow);
      this.loading = true;
      const data = await Promise.allSettled(downloadPromises);
      data.forEach((item) => {
        if (item.value) {
          downloadBlobFile(item.value.data);
        }
      });
      this.loading = false;
    },
  },
};
</script>
